import { Container as MuiContainer } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled(MuiContainer)`
    flex: 1;
    padding: ${({ theme }) => `0 ${theme.spacing(5)}px`};

    @media (min-width: ${({ theme }) =>
            `${theme.breakpoints.values['sm']}px`}) {
        padding: ${({ theme }) => `0 ${theme.spacing(5)}px`};
    }

    @media (min-width: ${({ theme }) =>
            `${theme.breakpoints.values['md']}px`}) {
        padding: ${({ theme }) => `0 ${theme.spacing(5)}px`};
        flex: auto;
    }
`;
